import { render, staticRenderFns } from "./quick-search.vue?vue&type=template&id=684042b6&"
import script from "./quick-search.vue?vue&type=script&lang=ts&"
export * from "./quick-search.vue?vue&type=script&lang=ts&"
import style0 from "./quick-search.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports